const React = require('react');

const Container = require('./Container.jsx');
const _TypeConfig = require('./TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

function Separator(props) {
    const config = props.config || {};
    let blockProps = {};
    const blockConfig = config.Config || config.config;
    if (blockConfig && blockConfig.Block) {
        blockProps = blockConfig.Block;
    }
    let borderWidth = '1px';
    if (blockProps && blockProps.borderWidth && blockProps.borderWidth.value && blockProps.borderWidth.value.length > 0) {
        borderWidth = `${blockProps.borderWidth.value}${blockProps.borderWidth.unit}`;
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                <td style={{ borderBottom: `${borderWidth} solid ${blockProps.color}` }}>
                    {props.builder && Utilities.Builder.dragOutline()}
                </td>
            </tr>
        </Container>
    );
}

const TypeConfig = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    _TypeConfig.options.firstPageOnly(),
                    {
                        display: 'Line Color',
                        name: 'color',
                        type: 'text',
                        value: '#e9e9e9'
                    }
                ]
            };
        },
        style: function () { return _TypeConfig.panel.layoutStyle({ bottom: '20px', top: '20px' }); }
    }
};
const TypeConfigV2 = {
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    _TypeConfig.options.firstPageOnly(),
                    {
                        display: 'Line Color',
                        group,
                        name: 'color',
                        type: 'color-left',
                        value: '#e9e9e9'
                    },
                    {
                        display: 'Line Width',
                        fullWidth: true,
                        group,
                        name: 'borderWidth',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider'
                    }
                ]
            };
        },
        style: () => {
            const group = 'block';
            return {
                group,
                options: [
                    {
                        disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                        display: 'Padding',
                        group,
                        name: 'paddingMargin',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'paddingMargin',
                        value: { 
                            paddingBottom: { unit: 'px', value: '20' }, 
                            paddingTop: { unit: 'px', value: '20' }
                        }
                    }
                ]
            }
        }
    }
};

module.exports = {
    Component: Separator,
    TypeConfig,
    TypeConfigV2
};